import type { DateTime } from "luxon";
import { useMemo } from "react";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";

/**
 * Every day the loaded schedule actually covers, ordered first to last.
 *
 * The range a URL date has to land inside. `hospitalData.weeks` spans
 * `department_data_history_weeks` back to the end of the loaded horizon, so a shared link, a stale
 * notification deep link or a bookmarked date from last month resolves to no week at all — and every
 * screen below indexes `weeks[weekIndex]`, which is a crash rather than an empty state.
 *
 * Shared by the classic mobile list and the gaps-first shell so the two cannot disagree about what
 * "out of range" means. `weeklyShifts[0].days` is briefly absent while a week hydrates during a
 * refresh, so a week without it contributes nothing instead of throwing.
 */
export const useLoadedStaffingDays = (): DateTime[] => {
	const { hospitalData } = useHospitalData();
	return useMemo(() => {
		const days: DateTime[] = [];
		for (const week of hospitalData.weeks) {
			const weekDays = week.weeklyShifts[0]?.days;
			if (weekDays?.length) days.push(...weekDays.map((day) => day.date));
		}
		return days;
	}, [hospitalData.weeks]);
};
